@if (data(); as repository) {
  <section class="hero-card">
    <div>
      <p class="eyebrow">Repository</p>
      <h1>{{ repository.name }}</h1>
      <p>{{ repository.organization.name }} / {{ repository.project.name }}</p>
    </div>
    <div class="hero-actions">
      <app-status-chip kind="verdict" [value]="repository.isActive ? 'Approved' : 'Blocked'"></app-status-chip>
      <a [href]="repository.remoteUrl" target="_blank" rel="noopener">Open in Azure DevOps</a>
    </div>
  </section>

  <section class="metric-grid">
    <app-metric-card label="PRs Reviewed" [value]="repository.summary.pullRequestsReviewed" />
    <app-metric-card label="Issues Found" [value]="repository.summary.issuesFound" tone="warn" />
    <app-metric-card label="High Issues" [value]="repository.summary.highIssues" tone="danger" />
    <app-metric-card label="Avg Issues / PR" [value]="(repository.summary.avgIssuesPerPullRequest | number:'1.1-2') ?? '0'" />
    <app-metric-card label="Block Rate" [value]="((repository.summary.blockRate | number:'1.1-1') ?? '0') + '%'" tone="danger" />
    <app-metric-card label="Latest Review" [value]="repository.summary.latestReviewAt ? (repository.summary.latestReviewAt | localDate:'short') : 'N/A'" />
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <div>
          <p class="eyebrow">Issue Categories</p>
          <h2>Where comments land</h2>
        </div>
      </div>

      @if (hasCategoryData()) {
        <div class="chart-shell">
          <canvas
            baseChart
            [data]="categoryChartData()"
            [type]="'bar'"
            [options]="{
              maintainAspectRatio: false,
              plugins: { legend: { display: false } },
              scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
            }">
          </canvas>
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No category data</strong>
          <span>No categorized review issues were recorded for this repository in the current range.</span>
        </div>
      }
    </article>

    <article class="panel">
      <div class="panel-head">
        <div>
          <p class="eyebrow">Pull Requests</p>
          <h2>Latest review activity</h2>
        </div>
      </div>

      @if (hasRecentPullRequests()) {
        <div class="pr-stack">
          @for (pullRequest of repository.recentPullRequests; track pullRequest.id) {
            <div class="pr-card">
              <div class="pr-line">
                <strong>#{{ pullRequest.azurePullRequestId }}</strong>
                <app-status-chip kind="verdict" [value]="pullRequest.verdict"></app-status-chip>
              </div>
              <div class="pr-title">{{ pullRequest.title }}</div>
              <div class="pr-meta">
                <span>{{ pullRequest.authorName }}</span>
                <span>{{ pullRequest.createdAt | localDate:'short' }}</span>
                <span>{{ pullRequest.totalIssues }} issues</span>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No recent review activity</strong>
          <span>No pull requests with review signals were found for this repository in the current range.</span>
        </div>
      }
    </article>
  </section>
} @else if (loading()) {
  <section class="state-card">Loading repository details…</section>
} @else if (error()) {
  <section class="state-card error">{{ error() }}</section>
}
